import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const NavigationItem = ({ to, children, exact = false }) => {
  const location = useLocation();
  const isActive = exact
    ? location.pathname === to
    : location.pathname.startsWith(to);

  return (
    <li className={isActive ? "active" : ""}>
      <NavLink to={to}>{children}</NavLink>
    </li>
  );
};

class Navigation extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/masonary.js");
  }

  render() {
    return (
      <>
        <div
          className={
            this.props.bgcolor !== ""
              ? `header-nav navbar-collapse collapse ${this.props.bgcolor}`
              : "header-nav navbar-collapse collapse"
          }
        >
          <ul className="nav navbar-nav">
            <NavigationItem to="/" exact>
              Home
            </NavigationItem>
            <NavigationItem to="/about">About us</NavigationItem>
            <NavigationItem to="/projects">Projects</NavigationItem>
            {/* <NavigationItem to="/services">Servies</NavigationItem> */}
            <NavigationItem to="/products">Products</NavigationItem>
            <NavigationItem to="/contactus">Contact Us</NavigationItem>
          </ul>
        </div>
      </>
    );
  }
}

export default Navigation;
// export default Navigation;
